import Map from "./common/Map";
import { MapItem } from "../utils/arcgisUtils";
import { useEffect, useState } from "react";
import { useAppContext } from "../hooks/useAppContext";
import { Boundary } from "../models/Boundary";
import { Checkbox, Menu } from "semantic-ui-react";
import { createBoundaryFromGraphic, createBoundryMapItem } from "../utils/boundaryUtils";

interface Props {
  boundaries?: Boundary[];
  onBoundariesEditCompleted?: (newBoundaries: Boundary[]) => void;
  onBoundariesEditStarted?: () => void;
  onEditBoundaryTypeOrComment?: (i: string) => void;
  allowMultipleBoundaries?: boolean;
  withPopup?: boolean;
  popUpHasAction?: boolean;
  height?: string;
  items?: MapItem[];
}

const MapWithBoundaries = ({
  boundaries,
  onBoundariesEditCompleted,
  onBoundariesEditStarted,
  onEditBoundaryTypeOrComment,
  allowMultipleBoundaries = true,
  withPopup = true,
  popUpHasAction = true,
  height,
  items,
}: Props) => {
  const { currentOrganization, organizationConfiguration } = useAppContext();
  const [showMapLegendSelected, setShowMapLegendSelected] = useState(false);
  const [showMapLayersListSelected, setShowMapLayersListSelected] = useState(false);
  const [polygons, setPolygons] = useState<MapItem[] | undefined>(undefined);

  useEffect(() => {
    if (boundaries?.length) {
      setPolygons(
        boundaries.map((boundary, i) => createBoundryMapItem(i.toString(), withPopup, popUpHasAction, boundary))
      );
    } else {
      setPolygons(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boundaries]);

  const handlePolygonsEdit = (polygons: __esri.Graphic[]) => {
    if (!onBoundariesEditCompleted) return;

    var newBoundaries: Boundary[] = polygons.map((polygon) => createBoundaryFromGraphic(polygon));
    onBoundariesEditCompleted(newBoundaries);
  };

  return (
    <>
      {organizationConfiguration?.system && (
        <>
          <Menu borderless size="small" style={{ marginBottom: "0px", border: "0", backgroundColor: "#f1f1f1" }}>
            <Menu.Item header>Map options:</Menu.Item>
            <Menu.Item position="right">
              <Checkbox
                slider
                label="Layers list"
                checked={showMapLayersListSelected}
                onChange={(e, data) => {
                  setShowMapLayersListSelected(data.checked ?? false);
                  if (data.checked) {
                    setShowMapLegendSelected(!data.checked);
                  }
                }}
              ></Checkbox>
            </Menu.Item>
            <Menu.Item>
              <Checkbox
                slider
                label="Map legend"
                checked={showMapLegendSelected}
                onChange={(e, data) => {
                  setShowMapLegendSelected(data.checked ?? false);
                  if (data.checked) {
                    setShowMapLayersListSelected(!data.checked);
                  }
                }}
              ></Checkbox>
            </Menu.Item>
          </Menu>

          <Map
            mapConfig={organizationConfiguration?.system?.arcGisMap}
            webMapItemId={currentOrganization?.esriConfig?.webMapItemId}
            items={items}
            onPopupClick={onEditBoundaryTypeOrComment}
            onPolygonsEditCompleted={onBoundariesEditCompleted ? handlePolygonsEdit : undefined}
            onPolygonsEditStarted={onBoundariesEditStarted}
            polygonsToEdit={polygons}
            allowMultiplePolygons={allowMultipleBoundaries}
            showLegend={showMapLegendSelected}
            showLayersList={showMapLayersListSelected}
            height={height}
          />
        </>
      )}
    </>
  );
};

export default MapWithBoundaries;
